import { Injectable } from "@angular/core";
import { BehaviorSubject, Head, Observable } from "rxjs";
import { Profile } from "../interfaces";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { User } from "@angular/fire/auth";
import { HttpService } from "./http.service";
import { UserService } from "./user.service";

@Injectable({ providedIn: "root" })
export class ProfileService {
  private profile$: BehaviorSubject<Profile>;
  private profile: Profile = <Profile>{};

  constructor(
    private http: HttpClient,
    private httpService: HttpService,
    private userService: UserService,
  ) {
    this.profile$ = new BehaviorSubject(this.profile);
  }

  getProfile$(): Observable<Profile> {
    return this.profile$.asObservable();
  }

  getProfile(): Profile {
    return this.profile;
  }

  setProfile$(profile: Profile): void {
    this.profile$.next(profile);
  }

  setProfile(profile: Profile): void {
    this.profile = profile;
  }

  getProfileDisplayName(): string {
    if (this.profile.firstName || this.profile.lastName) {
      return `${this.profile.firstName} ${this.profile.lastName}`;
    }
    if (this.profile.displayName) {
      return this.profile.displayName;
    }
    if (this.profile.email) {
      return this.profile.email
    }
    if (this.profile.contactNumber) {
      return this.profile.contactNumber
    }
    if (this.profile._id) {
      return this.profile._id;
    }
    return "";
  }

  getOrCreateProfile(user: User): Observable<Profile> {
    return this.http.post<Profile>(
      `${environment.apiBaseUrl}/profile`,
      this.userService.getUserPayload(user),
      this.httpService.getOptions(),
    );
  }

  getProfileById(profileId: string): Observable<Profile> {
    return this.http.get<Profile>(
      `${environment.apiBaseUrl}/profile/${profileId}`,
      this.httpService.getOptions(),
    );
  }

  updateProfile(
    profileId: string,
    partialProfile: Partial<Profile>,
  ): Observable<Profile> {
    return this.http.patch<Profile>(
      `${environment.apiBaseUrl}/profile/${profileId}`,
      partialProfile,
      this.httpService.getOptions(),
    );
  }

  deleteProfile(profileId: string): Observable<Profile> {
    return this.http.delete<Profile>(
      `${environment.apiBaseUrl}/profile/${profileId}`,
      this.httpService.getOptions(),
    );
  }

  getProfilesByUserId(userId: string): Observable<Profile[]> {
    return this.http.get<Profile[]>(
      `${environment.apiBaseUrl}/profiles/${userId}`,
      this.httpService.getOptions(),
    );
  }
}
